export default __webpack_public_path__ + "static/media/illus_2FA_4.35025e63.svg";